import { type FC, useState } from "react";
import { startSsoLogin } from "../auth/scrySso";
import { ScryShell } from "../scry/ScryShell";
import styles from "../scry/ScryShell.module.css";

export const UnauthenticatedView: FC = () => {
  const [error, setError] = useState(false);
  return <ScryShell>
  <h1>Video calls with your people.</h1>
  <p>Gather around the orb. Sign in with your wzrdz.cool account to start a call, then send your friends a link.</p>
  <button className={styles.primary} onClick={() => { try { startSsoLogin("/"); } catch { setError(true); } }}>Sign in with wzrdz.cool</button>
  {error && <p role="alert">Sign-in needs browser storage. Enable it for Scry, then try again.</p>}
  <p>Here to join? Open the invitation your host sent you. Guests don’t need an account.</p>
</ScryShell>;
};
